export default {
	project: {
		my_xs: 'My decisions',
		fields: {
			name: 'Title',
			name_explanation: 'Provide a title for your project',
			description: 'Mission',
			description_explanation: 'State your overall mission',
			vision: 'Vision',
			vision_explanation: 'State the long-term vision of the project',
			description_long: 'Description',
			description_long_explanation: 'E.g.: "Swiss mechatronics SME, 200 people, European automotive OEM market. Mission: become the European leader in smart sensors by 2030."',
			description_long_hint: 'The more precise the description (sector, size, mission), the more accurate the analysis.',
			description_long_warning_title: 'Description is brief',
			description_long_warning_body: "Your description is {{count}} characters long. The AI may infer a sector or context that doesn't match your organization. Do you want to enrich it before launching?",
			description_long_warning_enrich: 'Enrich',
			description_long_warning_continue: 'Launch anyway',
			ai_context: 'Specific focus and angles',
			ai_context_explanation: 'Indicate the angles, actors, or constraints the analysis should prioritize (e.g. a specific competitor, a regulatory dimension, a territory, a time constraint…).',
			fishbone_description: 'Strategic plan - To be',
			fishbone_description_explanation: '',
			reference: 'Reference',
			tags: 'Tags',
			likelihoods: 'Likelihoods',
			impacts: 'Impacts',
			types: {
				stakeholders: 'Stakeholders',
				stakeholders_long: 'Stakeholders project',
				stakeholders_explanation: 'Align the forces in presence',
				risks: 'Risks',
				risks_long: 'Risks project',
				risks_explanation: 'Turn your risks into openings',
				pro: 'Strategy Execution',
				pro_long: 'Strategy Execution project',
				pro_explanation: 'Implement with agility'
			},
			ai: {
				scenarios: {
					title: "Scenarios to explore",
					hint: "Processed by the private AI — no data sent outside. You can edit the text, time horizon, add or remove scenarios.",
					most_likely_label: "Most likely",
					most_likely_default: "The most likely trajectory if current trends persist: neither catastrophe nor euphoria — the median projection of the risks and opportunities already identified.",
					worst_label: "Worst case",
					worst_default: "Major risks materialize, openings are missed, stakeholders push back.",
					best_label: "Best case",
					best_default: "Risks are managed, openings are seized, stakeholders cooperate.",
					add: "Add a scenario",
					remove: "Remove this scenario",
					label_placeholder: "Scenario name",
					content_placeholder: "Hypotheses, key events, conditions for realisation…"
				},
				horizon_unit: {
					d: "days",
					w: "weeks",
					m: "months",
					y: "years"
				}
			},
		},
		messages: {
			delete_confirmation: 'Delete project',
			delete_confirmation_explanation:
				'Are you sure you would like to delete the project "{{name}}"? This action can\'t be undone.',
			clone_confirmation: 'Clone project',
			clone_confirmation_explanation:
				'Are you sure you would like to clone this project?',
			clone_in_progress: 'We are cloning your project, please wait...',
			delete_in_progress: 'We are deleting your project, please wait...'
		},
		actions: {
			edit: 'Edit project details',
			delete: 'Delete project',
			clone: 'Clone project',
			open: 'Open project'
		},
		shared_with_me: 'Shared with you (read-only)',
		readers_count: '{{count}} reader(s)',
		share: {
			tab: 'Sharing',
			description:
				'Invite people to view this project in read-only mode. They will not be able to modify or generate anything.',
			email_placeholder: 'email@example.com',
			invite: 'Invite',
			invalid_email: 'Invalid email address',
			already_member: 'This person already has access',
			invited: 'Invitation sent',
			invite_failed: 'Invitation failed',
			no_members: 'No readers yet',
			role_reader: 'Reader',
			revoke_confirm: 'Revoke this access?',
			revoked: 'Access revoked',
			revoke_failed: 'Revocation failed'
		}
	},
	option: {
		fields: {
			name_explanation: 'Please enter a name for this option'
		}
	},
	item: {
		name: 'Stakeholder',
		name_plural: 'Stakeholders',
		activeness_zones: {
			external_outer_positive: 'Neutral',
			external_inner_positive: 'Inactive',
			external_outer_negative: 'Neutral',
			external_inner_negative: 'Inactive',

			internal_low_positive: 'Low',
			internal_medium_positive: 'Medium',
			internal_high_positive: 'High',
			internal_low_negative: 'Low',
			internal_medium_negative: 'Medium',
			internal_high_negative: 'High',

			internal_positive: 'Catalysts',
			internal_negative: 'Inhibitors'
		},
		messages: {
			delete_confirmation: 'Delete stakeholder',
			delete_confirmation_explanation:
				"Are you sure you would like to delete this stakeholder? This action can't be undone and will impact all scenarios.\n\nIf you just want to hide the stakeholder for this scenario, click close, select the stakeholder and on the right column, click the \"eye\" button to disable for this scenario."
		},
		fields: {
			name: 'Name',
			description: 'Description',
			links: {
				outcoming: {
					name: 'Outcoming links'
				},
				incoming: {
					name: 'Incoming links'
				}
			},
			stakes: {
				name: 'Stakes relations'
			},
			indicators: {
				name: 'Indicators relations'
			},
			risks: {
				name: 'Risks relations'
			},
			opportunities: {
				name: 'Openings relations'
			},
			impact: {
				label: 'Importance',
				level: {
					low: 'Low',
					medium: 'Medium',
					high: 'High'
				}
			},
			trend: {
				label: 'Tonality',
				level: {
					green: 'Positive',
					neutral: 'Neutral',
					orange: 'At risk',
					red: 'Negative'
				}
			}
		},
		actions: {
			create_new: 'Create a new stakeholder',
			edit: 'Edit details',
			delete: 'Delete stakeholder',
			clone: 'Clone stakeholder'
		},
		no_x: 'No stakeholder',
		engagement: 'Engagement',
		importance: 'Importance',
		trust: 'Tonality',
		levels: {
			low: 'Low',
			medium: 'Medium',
			high: 'High',
			inactive_neutral: 'Inactive / Neutral',
			positive: 'Positive',
			positive_short: 'Pos.',
			negative: 'Negative',
			negative_short: 'Neg.',
			at_risk: 'At risk',
			neutral: 'Neutral'
		}
	},
	item_link: {
		no_x: 'No link',
		actions: {
			create_new: 'Create new link'
		}
	},
	item_comment: {
		no_x: 'No history',
		actions: {
			create_new: 'Create new history'
		}
	},
	tag: {
		name: 'Tag',
		name_plural: 'Tags',
		fields: {
			name: 'Tag',
			name_plural: 'Tags'
		},
		messages: {
			delete_confirmation: 'Delete tag',
			delete_confirmation_explanation:
				"Are you sure you would like to delete this tag? This action can't be undone.",
			no_x: 'No tag'
		},
		actions: {
			add_x: 'Add a tag',
			create_new: 'Create a tag',
			edit: 'Edit tag',
			delete: 'Delete tag'
		}
	},
	stake: {
		no_x: 'No stake',
		name: 'Stake',
		name_plural: 'Stakes',
		fields: {
			name: 'Name',
			reference: 'Reference',
			name_plural: 'Stakes',
			description: 'Description',
			evaluated_at: 'Last evaluation',
			weight: 'Weight',
			trend: 'Status',
			risks: {
				name: 'Risks relations',
				name_positive: 'Openings relations'
			},
			trend_tier: {
				strained: 'Precarious',
				mixed: 'Mixed',
				solid: 'Resilient'
			}
		},
		message: {
			no_x: 'No stake'
		},
		messages: {
			delete_confirmation: 'Delete stake',
			delete_confirmation_explanation:
				"Are you sure you would like to delete this stake? This action can't be undone and will impact all scenarios.\n\nIf you just want to hide the stake for this scenario, click close, select the stake and on the right column, click the \"eye\" button to disable for this scenario."
		},
		actions: {
			delete: 'Delete stake',
			edit: 'Edit stake',
			create_new: 'Create stake'
		}
	},

	indicator: {
		name: 'Indicator',
		name_plural: 'Indicators',
		no_x: 'No indicator',
		fields: {
			indicator_category: 'Category',
			name: 'Name',
			reference: 'Reference',
			name_plural: 'Indicators',
			evaluated_at: 'Last evaluation',
			frequency: 'Frequency',
			weight: 'Weight',
			description: 'Description'
		},
		action: {
			add_x: 'Add an indicator point'
		},
		message: {
			no_x: 'No indicator'
		},
		messages: {
			delete_confirmation: 'Delete indicator',
			delete_confirmation_explanation:
				"Are you sure you would like to delete this indicator? This action can't be undone and will impact all scenarios.\n\nIf you just want to hide the indicator for this scenario, click close, select the indicator and on the right column, click the \"eye\" button to disable for this scenario."
		},
		actions: {
			delete: 'Delete indicator',
			edit: 'Edit indicator',
			create_new: 'Create indicator'
		}
	},

	scenario: {
		name: 'Scenario',
		name_plural: 'Scenarios',
		no_x: 'No scenario',
		baseline: 'Baseline',
		fields: {
			name: 'Name',
			name_long: 'Scenario name',
			score: 'Scenario score',
			description: 'Description',
			impacts: 'Impacts description',
			generate_simulation: 'Generate simulation automatically',
			simulation_query: 'Hypothesis and time horizon'
		},
		placeholders: {
			simulation_query:
				'E.g.: What would happen if oil prices increased by 50% within 2 years? What would be the consequences on stakeholders and identified risks?'
		},
		messages: {
			delete_confirmation: 'Delete scenario',
			delete_confirmation_explanation:
				"Are you sure you would like to delete this scenario? This action can't be undone.",
			switch_scenario: 'Switch to baseline or another scenario',
			creation_in_progress:
				'Please wait while your scenario is being prepared...',
			simulation_explanation:
				'AI will analyze your hypothesis and propose modifications to stakeholders, risks and stakes of the project to simulate this scenario.',

			promote_as_baseline: {
				title: 'Promote this scenario as the new baseline',
				explanation:
					'Are you sure you would like to promote the scenario "<0>{{name}}</0>" as the new baseline? This action can\'t be undone.',
				keep_current_baseline_as_scenario_question:
					'What would you like to do with the former baseline?',
				keep_current_baseline_as_scenario_question_yes:
					'I want to keep it and give it the following name',
				keep_current_baseline_as_scenario_question_no:
					'Nothing, it can be deleted',
				keep_scenario_question:
					'Would you like to keep a copy of the scenario now promoted as the new baseline?',
				keep_scenario_question_yes: 'Yes, keep a copy',
				keep_scenario_question_no: "No, I don't need a copy",
				loading: 'Promoting scenario as new baseline...'
			},

			best_evaluation: 'Best case across all scenarios'
		},
		actions: {
			create_new: 'Create a new scenario',
			create_new_from_baseline: 'Create a new scenario from baseline',
			save_as_new_baseline: 'Save as new baseline',
			clone: 'Clone scenario',
			edit: 'Edit scenario',
			delete: 'Delete scenario',
			next: 'Go to next scenario',
			previous: 'Go to previous scenario',
			previous_baseline: 'Go to baseline scenario',
			continue_with_ai: 'Continue with AI'
		},
		ai: {
			toggle: 'Generate this scenario with AI',
			toggle_subtitle:
				'Based on your hypothesis, AI will propose 4 plausible variants then generate the selected scenarios.',
			explanation:
				'Describe your hypothesis and set the horizon. AI will propose 4 variants you can pick from before generating one or more scenarios.',
			hypothesis_label: 'Hypothesis',
			hypothesis_placeholder:
				'E.g. The main competitor announces an exclusive partnership with a major public-sector player.',
			suggestions_label: 'Suggestions tailored to your project',
			click_to_use: 'Click to use this suggestion',
			no_suggestions: 'No suggestions available right now.',
			suggestions_error: 'Could not generate suggestions right now.',
			horizon_label: 'Horizon',
			horizon_unit_label: 'Unit',
			scope_label: 'Scope (optional)',
			scope_placeholder: 'E.g. European subsidiary, B2B segment, ongoing M&A…',
			focus_axes_label: 'Focus areas (optional)',
			focus_axes_placeholder: 'Pick one or more areas',
			zone_public_tooltip:
				'Project subject and hypothesis are neutralised (in-VPC) before being sent to the public search to collect external stakeholders, comparable precedents, weak signals and sector dynamics.',
			public_note:
				'At generation time, a public search will be triggered on an anonymised subject to collect external stakeholders, comparable precedents, weak signals and sector dynamics.',
			modal_title: 'AI scenario generation',
			variants_intro:
				'Here are the variants AI suggests for your hypothesis. Check the ones you want to expand into scenarios.',
			requesting_variants: 'Generating variants…',
			validate_count: 'Validate ({{count}})',
			interrupted: 'Generation interrupted (connection lost or server timeout). Create a new scenario to run the generation again.',
			result_too_large: 'The generation result is too large to be recovered. Please restart the generation.',
			modifications: 'Modifications',
			new_elements: 'New elements',
			no_changes: 'No changes suggested by AI.',
			review_title: 'Proposed changes',
			review_subtitle: 'Tick / untick then validate',
			review_hint: 'Untick an item to skip importing it.',
			badge_new: 'New',
			before_label: 'Before',
			value: {
				disabled: 'Disabled'
			},
			step: {
				loading_project: 'Loading project context…',
				preparing_prompt: 'Preparing AI prompt…',
				asking_ai: 'AI analysis…',
				parsing_variants: 'Formatting variants…',
				reformulating: 'Neutral subject reformulation…',
				deep_research: 'Anonymised public search…',
				private_analysis: 'Private scenario analysis…',
				processing_stakeholders: 'Computing stakeholder impacts…',
				processing_stakes: 'Computing stake impacts…',
				processing_risks: 'Computing risk impacts…',
				processing_indicators: 'Computing constraint impacts…',
				reformatting: 'Formatting results…',
				started: 'Starting…',
				completed: 'Completed'
			},
			generate_count: 'Generate ({{count}})',
			in_progress: 'In progress…',
			done: 'Done',
			focus_axis: {
				regulatory: 'Regulatory',
				market: 'Market',
				tech: 'Technology',
				social: 'Social',
				partnership: 'Partnership',
				geopolitical: 'Geopolitical',
				crisis: 'Crisis'
			},
			unit: {
				days: 'days',
				weeks: 'weeks',
				months: 'months',
				years: 'years'
			}
		}
	},
	fishbone_branch: {
		name: 'Bone',
		name_plural: 'Bones',
		fields: {
			completion: 'Completion',
			trend: 'Status',
			name: 'Name',
			description: 'Description',
			weight: 'Weight',
			responsible: 'Responsible',
			dates: 'Dates',
			startOn: 'Start',
			endOn: 'End'
		},
		messages: {
			delete_confirmation: 'Delete strategic plan branch',
			delete_confirmation_explanation:
				"Are you sure you would like to delete this branch? This action can't be undone and will impact all scenarios.\n\nIf you just want to hide the branch for this scenario, click close, select the branch and on the right column, click the \"eye\" button to disable for this scenario."
		},
		actions: {
			add: 'Add a bone',
			clone: 'Clone bone',
			edit: 'Edit bone',
			delete: 'Delete bone'
		}
	},
	fishbone_item: {
		name: 'Sub-bone',
		name_plural: 'Sub-bone',
		fields: {
			name: 'Name',
			description: 'Description',
			completion: 'Completion',
			trend: 'Status',
			weight: 'Weight',
			responsible: 'Responsible',
			startOn: 'Start',
			endOn: 'End',
			dates: 'Dates'
		},
		messages: {
			delete_confirmation: 'Delete sub-bone',
			delete_confirmation_explanation:
				"Are you sure you would like to delete this measure? This action can't be undone and will impact all scenarios.\n\nIf you just want to hide the measure for this scenario, click close, select the measure and on the right column, click the \"eye\" button to disable for this scenario."
		},
		actions: {
			add: 'Add a sub-bone',
			clone: 'Clone sub-bone',
			edit: 'Edit sub-bone',
			delete: 'Delete sub-bone'
		}
	},
	risk: {
		name: 'Risk',
		name_plural: 'Risks',
		name_positive: 'Opening',
		name_plural_positive: 'Openings',
		fields: {
			name: 'Name',
			description: 'Description - Indicators of occurence',
			reference: 'Reference',
			risk_category: 'Category',
			likelihood: 'Likelihood',
			likelihood_level: 'Likelihood level name',
			impact: 'Impact',
			impact_level: 'Impact level name',
			matching_opportunity: 'Matching opening',
			matching_risks: 'Risk relations',
			evaluated_at: 'Last evaluation',
			exposure: 'Exposure',
			exposure_positive: 'Upside',
			risk: 'Risk',

			opportunity: {
				name: 'Opening'
			}
		},
		impacts: {
			1: 'Negligible',
			2: 'Minor',
			3: 'Moderate',
			4: 'Major',
			5: 'Extreme'
		},
		likelihoods: {
			1: 'Highly Unlikely',
			2: 'Unlikely',
			3: 'Possible',
			4: 'Likely',
			5: 'Almost Certain'
		},

		messages: {
			delete_confirmation: 'Delete risk',
			delete_confirmation_explanation:
				"Are you sure you would like to delete this risk? This action can't be undone and will impact all scenarios.\n\nIf you just want to hide the risk for this scenario, click close, select the risk and on the right column, click the \"eye\" button to disable for this scenario.",
			delete_opening: 'Delete opening',
			delete_opening_explanation:
				"Are you sure you would like to delete this opening? This action can't be undone and will impact all scenarios.\n\nIf you just want to hide the opening for this scenario, click close, select the opening and on the right column, click the \"eye\" button to disable for this scenario.",
			no_x: 'No risk',
			no_category: 'No category',
			no_x_positive: 'No opening'
		},
		no_x: 'No risk',
		actions: {
			create_new: 'Create a new risk or opening',
			create: 'Add a risk',
			create_opening: 'Add an opening',
			edit: 'Edit risk',
			edit_opportunity: 'Edit opening',
			delete: 'Delete risk',
			delete_opportunity: 'Delete opening',
			clone: 'Clone risk'
		}
	},
	risk_category: {
		name: 'Category',
		name_plural: 'Categories',
		fields: {
			name: 'Name'
		},
		messages: {
			delete_confirmation: 'Delete category',
			delete_confirmation_explanation:
				"Are you sure you would like to delete this category? This action can't be undone.",
			no_x: 'No category'
		},
		default_values: {
			name: {
				1: 'Existential',
				2: 'Strategic',
				3: 'Operational'
			}
		},
		actions: {
			create_new: 'Create a new Category',
			edit: 'Edit Category',
			delete: 'Delete Category',
			add_x: 'Add a Category'
		}
	},
	indicator_category: {
		name: 'Category',
		name_plural: 'Categories',
		fields: {
			name: 'Name'
		},
		messages: {
			delete_confirmation: 'Delete category',
			delete_confirmation_explanation:
				"Are you sure you would like to delete this category? This action can't be undone.",
			no_x: 'No category',
			unassigned: 'Unassigned'
		},
		default_values: {
			name: {
				1: 'Financial',
				2: 'Customer',
				3: 'Internal processes',
				4: 'Learning & growth'
			}
		},
		actions: {
			create_new: 'Create a new Category',
			edit: 'Edit Category',
			delete: 'Delete Category',
			add_x: 'Add a Category'
		}
	},
};
